/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * EQUAL operator looks for values in the given key that are equal to the given value.
 */
export interface KeyEqualLabelKeyLabelValue {
    /** The key to compare against. */
    key: string;
    /** The value to compare against. */
    value: string;
}
